import React from 'react';
import PortalLogin from '@/components/PortalLogin';

// ROUT Client Portal login. Uses the shared PortalLogin template so it matches
// the approved Total-E Management login layout, spacing, controls and footer.
const RoutClientLogin = () => <PortalLogin portal="client" />;

export default RoutClientLogin;
